import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/app/auth/AuthClientLayout.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/shared/assets/brand/logo.svg");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/shared/assets/icons/spinner.svg");
